import { render, staticRenderFns } from "./top.vue?vue&type=template&id=33c7b5d6&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"
import style0 from "./top.vue?vue&type=style&index=0&id=33c7b5d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c7b5d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c7b5d6')) {
      api.createRecord('33c7b5d6', component.options)
    } else {
      api.reload('33c7b5d6', component.options)
    }
    module.hot.accept("./top.vue?vue&type=template&id=33c7b5d6&scoped=true", function () {
      api.rerender('33c7b5d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/components/top.vue"
export default component.exports